export default __webpack_public_path__ + "static/media/Jubilat-Italic.386bd1fd.otf";